// extracted by mini-css-extract-plugin
module.exports = {"experience":"StudioExperienceBlock_experience__o5FwT"};